module.exports = __webpack_public_path__ + "static/media/hypokaustenheizung1_tn.361235f2.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/Sizilien/hypokaustenheizung1_tn.jpg
// module id = 770
// module chunks = 0